import React, { useState, useEffect, ChangeEvent } from 'react';
import { Input, Button, Row, Col, Form, FormGroup } from 'reactstrap';
import Viewer from 'react-viewer';
import moment from 'moment';

function MatriculaForm(props: any) {
  const { data, setData, gallery, galleryContainer, isLoading, onAccept, onReject, onCreateMatricula } = props;

  const [hasMotivoRechazo, setHasMotivoRechazo] = useState(false);

  useEffect(() => {
    setHasMotivoRechazo(!!data.motivo_rechazo);
  }, [data.id]);

  const accept = () => {
    if (!onAccept) {
      return;
    }

    onAccept();
  };

  const createMatricula = () => {
    if (!onCreateMatricula) {
      return;
    }

    onCreateMatricula();
  };

  const reject = () => {
    if (!onReject) {
      return;
    }

    onReject();
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { target } = event;

    // Guardamos el nuevo valor
    setData({
      ...data,
      [target.name]: target.value,
    });
  };

  return (
    <Form>
      <Row>
        <Col sm={6}>
          <h6 className="heading text-muted mb-4">
            Datos personales
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Nombre</label>
                <p>{ data.nombre || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Apellido</label>
                <p>{ data.apellido || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Tipo documento</label>
                <p>{ data.tipo_documento || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Número documento</label>
                <p>{ data.nro_documento || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>CUIT</label>
                <p>{ data.cuit || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Sexo</label>
                <p>{ (data.sexo == 'M') ? 'Masculino' : 'Femenino' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Teléfono</label>
                <p>{ data.prefijo_telefono || '' } - { data.telefono || '' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Email</label>
                <p>{ data.email || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Fecha de nacimiento</label>
                <p>{ moment(data.fecha_nac, 'YYYY-MM-DD').format('DD/MM/YYYY') || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>País</label>
                <p>{ data.pais_nac_id == 1 ? data.pais_nac : 'Extranjero' }</p>
              </FormGroup>
            </Col>
          </Row>
          { data.pais_nac_id == 1
            ?
              <>
                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <label className='form-control-label'>Provincia</label>
                      <p>{ data.provincia_nac || '-' }</p>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup>
                      <label className='form-control-label'>Partido</label>
                      <p>{ data.partido_nac || '-' }</p>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <label className='form-control-label'>Localidad</label>
                      <p>{ data.localidad_nac || '-' }</p>
                    </FormGroup>
                  </Col>
                </Row>
              </>
            : null
          }
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Delegación
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Número</label>
                <p>{ data.delegacion_nro || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Localidad</label>
                <p>{ data.delegacion_localidad || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Dirección particular
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Calle</label>
                <p>{ data.particular_calle || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Número</label>
                <p>{ data.particular_numero || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Piso</label>
                <p>{ data.particular_piso || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Departamento</label>
                <p>{ data.particular_dpto || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Teléfono</label>
                <p>{ data.particular_prefijo_telefono || '' } - { data.particular_telefono || '' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Código postal</label>
                <p>{ data.particular_codigo_postal || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Provincia</label>
                <p>{ data.particular_provincia || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Partido</label>
                <p>{ data.particular_partido || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>Localidad</label>
                <p>{ data.particular_localidad || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Dirección legal
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Calle</label>
                <p>{ data.legal_calle || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Número</label>
                <p>{ data.legal_numero || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Piso</label>
                <p>{ data.legal_piso || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Departamento</label>
                <p>{ data.legal_dpto || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Teléfono</label>
                <p>{ data.legal_prefijo_telefono || '' } - { data.legal_telefono || '' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Código postal</label>
                <p>{ data.legal_codigo_postal || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Partido</label>
                <p>{ data.legal_partido || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Localidad</label>
                <p>{ data.legal_localidad || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Título universitario
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Institución</label>
                <p>{ data.titulo_institucion || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Título</label>
                <p>{ data.titulo_nombre || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>Fecha obtención</label>
                <p>{ moment(data.titulo_fecha, 'YYYY-MM-DD').format('DD/MM/YYYY') || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Pago
          </h6>
          { data.forma_pago === 'tarjeta' &&
            <>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Modalidad de pago</label>
                    <p>Tarjeta</p>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Tipo de Tarjeta</label>
                    <p>{ data.tipo_tarjeta || '-' }</p>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Número de Tarjeta</label>
                    <p>{ data.numero_tarjeta_cbu || '-' }</p>
                  </FormGroup>
                </Col>
              </Row>
            </>
          }
          { data.forma_pago === 'bancaria' &&
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <label className='form-control-label'>Modalidad de pago</label>
                  <p>Cuenta Bancaria</p>
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <label className='form-control-label'>CBU</label>
                  <p>{ data.numero_tarjeta_cbu || '-' }</p>
                </FormGroup>
              </Col>
            </Row>
          }
          { data.forma_pago === 'efectivo' &&
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <label className='form-control-label'>Modalidad de pago</label>
                  <p>Efectivo</p>
                </FormGroup>
              </Col>
            </Row>
          }
          { data.forma_pago !== 'tarjeta' && data.forma_pago !== 'bancaria' && data.forma_pago !== 'efectivo' &&
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <label className='form-control-label'>Modalidad de pago</label>
                  <p>-</p>
                </FormGroup>
              </Col>
            </Row>
          }
          { data.state_id != 2
            ?
              <>
                <hr className="my-4" />
                <h6 className="heading text-muted mb-4">
                  Rechazo
                </h6>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <label className='form-control-label'>Motivo de rechazo</label>
                      {
                        hasMotivoRechazo
                          ?
                            <p>{ data.motivo_rechazo }</p>
                          :
                            <Input
                              id="motivo_rechazo"
                              name="motivo_rechazo"
                              type="textarea"
                              value={data.motivo_rechazo ?? ''}
                              onChange={handleInputChange}
                              disabled={isLoading}
                              required
                            />
                      }
                    </FormGroup>
                  </Col>
                </Row>
              </>
            : null
          }
        </Col>
        <Col sm={6}>
          <div className="">
            <label className="form-control-label">Adjuntos</label>
            <div
              id="gallery-container"
              style={{ height: '80vh' }}
              ref={galleryContainer}
            >
              {Array.isArray(gallery) &&
              gallery.length &&
              galleryContainer.current ? (
                    <Viewer
                      container={galleryContainer.current}
                      noClose={true}
                      visible={true}
                      disableMouseZoom={true}
                      downloadable={true}
                      disableKeyboardSupport={true}
                      zoomSpeed={0.5}
                      downloadInNewWindow={true}
                      noImgDetails={true}
                      scalable={false}
                      showTotal={false}
                      defaultScale={1.25}
                      defaultImg={{
                        src: require('../../../assets/img/404.png'),
                      }}
                      images={gallery}
                    />
                  ) : null}
            </div>
          </div>
        </Col>
      </Row>
      {
        onAccept || onReject
          ? <Row>
              <hr className="my-4" />
              <Col className="text-center">
                <Button color="danger" onClick={ reject } disabled={ isLoading }>Rechazar</Button>
                <Button color="success" onClick={ accept } disabled={ isLoading }>Aceptar</Button>
              </Col>
            </Row>
          : null
      }
      {
        data.state_id == 2 && data.turno_jura_id
          ?
            <>
              <hr className="my-4" />
              <h6 className="heading text-muted mb-4">
                Turno de Jura
              </h6>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Lugar</label>
                    <p>{ data.tj_lugar }</p>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Fecha y Hora</label>
                    <p>{ data.tj_fecha_hora }</p>
                  </FormGroup>
                </Col>
              </Row>
            </>
          : null
      }
      {
        (
          !!data.payment_id &&
          !!data.payment &&
          !!data.payment.payment_id &&
          data.payment.status === 'approved'
        )
          ?
            <>
              <h6 className="heading text-muted mb-4">
                Pago
              </h6>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>ID de Pago</label>
                    <p>{ data.payment.payment_id }</p>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Preference ID</label>
                    <p>{ data.payment.preference_id }</p>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <label className='form-control-label'>Monto</label>
                    <p>$ { data.payment_amount }</p>
                  </FormGroup>
                </Col>
              </Row>
            </>
          : null
      }
      {
        data.matriculate_id
          ?
            <>
              <hr className="my-4" />
              <h6 className="heading text-muted mb-4">
                Matrícula
              </h6>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Número de Matrícula</label>
                    <p>{ data.matriculate_id }</p>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Número de Tomo</label>
                    <p>{ data.matricula_ck?.MTR001_N_TOMO }</p>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <label className='form-control-label'>Número de Folio</label>
                    <p>{ data.matricula_ck?.MTR001_N_FOLIO }</p>
                  </FormGroup>
                </Col>
              </Row>
            </>
          : null
      }
      {
        data.state_id == 2 && !data.matriculate_id
          ?
            <Row>
              <hr className="my-4" />
              <Col className="text-center">
                <Button
                  color="success"
                  onClick={ createMatricula }
                  disabled={ isLoading }>
                  Crear Matrícula
                </Button>
              </Col>
            </Row>
          : null
      }
    </Form>
  );
}

export default MatriculaForm;
